import { render, staticRenderFns } from "./EditMarkModal.vue?vue&type=template&id=6b86e3b0&scoped=true&"
import script from "./EditMarkModal.vue?vue&type=script&lang=js&"
export * from "./EditMarkModal.vue?vue&type=script&lang=js&"
import style0 from "./EditMarkModal.vue?vue&type=style&index=0&lang=less&"
import style1 from "./EditMarkModal.vue?vue&type=style&index=1&id=6b86e3b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b86e3b0",
  null
  
)

export default component.exports